import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import Card from 'design-system/components/Card';
import { Paragraph } from 'design-system/components/Text';

interface PlaceholderProps {
  title: string;
  message?: string;
  loading?: boolean;
}

const Placeholder = ({ title, message, loading }: PlaceholderProps) => {
  return (
    <Card data-test='module__placeholder'>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        {message && <Paragraph>{message}</Paragraph>}
        {loading && <LoadingIndicator />}
      </Card.Body>
    </Card>
  );
};

export default Placeholder;
